import i18n from '@/utils/i18n';

const filters =
  [
    {
      name: "title",
      placeholder: i18n.t('form.title_placeholder'),
      type: "text",
      label: i18n.t('form.title'),
    }
  ];

export default filters